import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
@Component({
	selector: 'pcm-timesheet-progress',
	templateUrl: './timesheet-progress.component.html',
	styleUrls: ['./timesheet-progress.component.scss']
})
export class TimesheetProgressComponent  implements OnChanges {
	setSubmitted;
	setManager;
	setSam;
	setFullyVerified;

	setSubmittedCorrections;
	setManagerCorrections;
	setSamCorrections;
	setFullyVerifiedCorrections;

	currentSubmitted;
	currentMgr;
	currentSam;
	currentFullyVerified;

	@Input() timesheetStatusDescription;
	@Input() timesheetApprovalStatus
	@Input() timesheetRejectStatus;
	@Input() timesheetCorrections;
	@Input() timesheetCorrectionsEntries;

	constructor(
		public configService: ConfigService
	) { }

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['timesheetStatusDescription'] || changes['timesheetApprovalStatus'] || changes['timesheetRejectStatus'] 
			|| changes['timesheetCorrections'] || changes['timesheetCorrectionsEntries']) {
			this.getSubmitted();
			this.getMgr();
			this.getSam();
			this.getFullyVerified();
		}
	}

	getSubmitted() {
		let state = [''];
		let optionalText;
		const isUnsubmittedStatus = this.timesheetStatusDescription === this.configService.timesheetUnsubmitStatus
			|| this.timesheetStatusDescription === this.configService.timesheetReasonSubmittedStatus;

		if (isUnsubmittedStatus) {
			state = ['incomplete'];
			optionalText = 'Pending';
			this.currentSubmitted = undefined;
		} else if ((this.timesheetStatusDescription === '' || (this.timesheetCorrectionsEntries === null || !this.timesheetCorrectionsEntries)) 
			&& this.timesheetCorrections) {
			state = ['incomplete'];
			optionalText = 'No Correction Started';
			this.currentSubmitted = undefined;
		} else if (this.timesheetStatusDescription === '') {
			state = ['incomplete'];
			optionalText = 'Pending';
			this.currentSubmitted = undefined;
		} else {
			state = ['complete'];
			optionalText = '';
			this.currentSubmitted = 1;
		}

		if (this.timesheetCorrections && !isUnsubmittedStatus) {
			this.setSubmitted = [{ text: 'Submitted', state: ['Complete'], optionalText: '' }];
			this.setSubmittedCorrections = [{ text: 'Submitted', state: state, optionalText: optionalText }];
		} else if (this.timesheetCorrections && isUnsubmittedStatus) {
			this.setSubmitted = [{ text: 'Submitted', state: ['Complete'], optionalText: '' }];
			this.setSubmittedCorrections = [{ text: 'Submitted', state: ['incomplete'], optionalText: 'Pending' }];
		} else {
			this.setSubmitted = [{ text: 'Submitted', state: state, optionalText: optionalText }];
		}
	}

	getMgr() {
		let state = [''];
		let optionalText;

		if ((this.timesheetCorrectionsEntries === null || !this.timesheetCorrectionsEntries || this.currentSubmitted === undefined) 
			&& this.timesheetCorrections) { 
			optionalText = '';
			this.currentMgr = undefined;
		} else if ((this.timesheetStatusDescription === this.configService.timesheetPendingMGR) 
			|| (this.timesheetStatusDescription === this.configService.timesheetPedingStatusDescription)) {
			state = ['incomplete'];
			optionalText = 'Pending';
			this.currentMgr = undefined;
		} else if ((this.timesheetStatusDescription === this.configService.timesheetPendingSAM) 
				|| (this.timesheetApprovalStatus === this.configService.timesheetApprovalStatus)
				|| (this.timesheetStatusDescription === this.configService.timesheetReasonSubmittedStatus)) {
			state = ['complete'];
			optionalText = 'Verified';
			this.currentMgr = 1;
		} else if (this.timesheetRejectStatus === this.configService.timesheetRejectedMGR) {
			state = ['incomplete', 'error'];
			optionalText = 'Rejected';
			this.currentMgr = undefined;
		} else {
			optionalText = '';
			this.currentMgr = undefined;
		}

		if (this.timesheetCorrections) {
			this.setManager = [{ text: 'Manager', state: ['Complete'], optionalText: 'Verified' }];
			this.setManagerCorrections = [{ text: 'Manager', state: state, optionalText: optionalText }];
		} else {
			this.setManager = [{ text: 'Manager', state: state, optionalText: optionalText }];
		}
	}

	getSam() {
		let state = [''];
		let optionalText;

		if ((this.timesheetCorrectionsEntries === null || !this.timesheetCorrectionsEntries || this.currentSubmitted === undefined) 
			&& this.timesheetCorrections) { 
			optionalText = '';
			this.currentSam = undefined;
		} else if ((this.timesheetStatusDescription === this.configService.timesheetPendingSAM) 
			|| (this.timesheetStatusDescription === this.configService.timesheetPedingStatusDescription)) {
			state = ['incomplete'];
			optionalText = 'Pending';
			this.currentSam = undefined;
		} else if ((this.timesheetStatusDescription === this.configService.timesheetPendingMGR) 
				|| (this.timesheetApprovalStatus === this.configService.timesheetApprovalStatus)
				|| (this.timesheetStatusDescription === this.configService.timesheetReasonSubmittedStatus)) { 
			state = ['complete'];
			optionalText = 'Verified';
			this.currentSam = 1;
		} else if (this.timesheetRejectStatus === this.configService.timesheetRejectedSAM) {
			state = ['incomplete', 'error'];
			optionalText = 'Rejected';
			this.currentSam = undefined;
		} else {
			optionalText = '';
			this.currentSam = undefined;
		}

		if (this.timesheetCorrections) {
			this.setSam = [{ text: 'SAM', state: ['Complete'], optionalText: 'Verified' }];
			this.setSamCorrections = [{ text: 'SAM', state: state, optionalText: optionalText }];
		} else {
			this.setSam = [{ text: 'SAM', state: state, optionalText: optionalText }];
		}
	}

	getFullyVerified() {
		let state = [''];
		let optionalText;

		if ((this.timesheetCorrectionsEntries === null || !this.timesheetCorrectionsEntries || this.currentSubmitted === undefined) 
			&& this.timesheetCorrections) { 
			optionalText = '';
			this.currentFullyVerified = undefined;
		} else if (this.timesheetApprovalStatus === this.configService.timesheetApprovalStatus || 
			this.timesheetStatusDescription === this.configService.timesheetReasonSubmittedStatus) {
			state = ['complete'];
			this.currentFullyVerified = 1;
		} else {
			optionalText = '';
			this.currentFullyVerified = undefined;
		}

		if(this.timesheetCorrections) {
			this.setFullyVerified = [{ text: 'Fully Verified', state: ['Complete'], optionalText: '' }];
			this.setFullyVerifiedCorrections = [{ text: 'Fully Verified', state: state, optionalText: optionalText }];
		} else {
			this.setFullyVerified = [{ text: 'Fully Verified', state: state, optionalText: optionalText }];
		}
	}
}
